import { DataGridPro, GridColumns, GridRowsProp, GridSortModel } from "@mui/x-data-grid-pro";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
interface DataGridProps {
	rows: GridRowsProp;
	columns: GridColumns;
	[key: string]: any; // Additional props
}

const DataGrid: React.FC<DataGridProps> = ({ rows, columns, localeText, ...rest }) => {
	const { t } = useTranslation();
	const [sortModel, setSortModel] = useState<GridSortModel>([
		{ field: columns[0]?.field, sort: "asc" } ]);
	return (
		<DataGridPro rows={rows}
		columns={columns}
		sortModel={sortModel}
		onSortModelChange={(newModel : any ) => {
			setSortModel(newModel)}}
		localeText={{
			...localeText,
			MuiTablePagination: {
				labelRowsPerPage: t("common_rows-per-page"),
				...(localeText?.MuiTablePagination ?? {}),
			},
		}}
		disableColumnMenu {...rest} />
	);
};

export default DataGrid;
